import { RestApiClient } from 'ifield-core-components'

/**
 * 指定 item_key のシステム設定取得
 * @param {String} itemKey item_key
 * @returns {Object} データ
 */
const getSystemSettingByItemKey = async (itemKey) => {
  const url = RestApiClient.createApiUrl('system_setting')
  url.searchParams.append('item_key', itemKey)
  const json = await RestApiClient.executeGetApi(url)
  return json.data
}

/**
 * 初期 state 取得
 * @returns
 */
const getDefaultState = () => ({
  settings: {},
})

export default {
  namespaced: true,
  state: getDefaultState(),
  persistentStates: [],
  mutations: {
    /**
     * stateを初期化する
     * @param {*} state
     */
    resetState(state) {
      Object.assign(state, getDefaultState())
    },
    /**
     * 設定項目を設定する
     * @param {*} state
     * @param {Object} targets 設定項目
     */
    setSettingItem(state, item) {
      if (!item?.item_key) return
      // リアクティブをトリガーするために全体の shallow copy を代入する
      state.settings = {
        ...state.settings,
        [item.item_key]: item,
      }
    },
  },
  getters: {
    /**
     * 指定 item_key の item_value 値を取得する関数
     * @param {*} state
     * @returns {Function} 指定 item_key の item_value 値を取得する関数
     *  @param {String} itemKey item_key
     *  @returns {String} item_value キーが無い場合は undefined
     */
    getItemValueByItemKey: (state) => (itemKey) =>
      state.settings[itemKey]?.item_value,
  },
  actions: {
    /**
     * stateをリセットする
     */
    resetState({ commit }) {
      commit('resetState')
    },
    /**
     * 指定 item_key の設定を更新する
     * @param {String} itemKey item_key
     */
    async updateSettingByItemKey({ commit }, itemKey) {
      const settings = await getSystemSettingByItemKey(itemKey)
      commit('setSettingItem', settings[0])
    },
  },
}
